import InvoicingScheduledPayment from './InvoicingScheduledPayment';

export default InvoicingScheduledPayment;
